<template>
  <div class="select-part">
    <label class="name">{{filterName}}</label>
    <div class="select-item" :class="{'larges':index==0}">
      <template v-for="(item,itemIndex) in childItem" >
        <select-item :key="itemIndex" :item="item" :isActive="value==itemIndex" v-model="itemIndex" @change="clickItem" />
      </template>
      <slot name="second"></slot>
    </div>
  </div>
</template>

<script>

import FiltersItem from '../selectModel/filtersItem.vue';
import SelectItem from './select-item.vue';
export default {
   components: {  FiltersItem, SelectItem },
   name:'filter-colum',
   //props里面的value为组件v-model绑定的属性值  修改使用方法：this.$emit("input",info.index)
   props:["filterName","childItem","index","curFilter","value"],
   data(){
     return{
       isActive:true
     }
   },
   methods:{
     clickItem(info){
      // console.log("点击",info);
      // 如果序号index相同，则是删除操作
      if(this.value == info.index){
        this.$emit("input",-1)
        this.$emit("change",-1)
      }else{
        this.$emit("input",info.index)
        this.$emit("change",info)
      }
      
      
     }
   }
   
}
</script>

<style lang="scss" scoped>

</style>